module.exports = "<div class=\"chart-container\"\n     [id]=\"chartId\"></div>"